<template>
  <div class="card">
    <div class="card-body">
      <div class="pt-20 pb-20 pr-20 pl-20">
        <h5 class="card-title text-center font-weight-bold">My Leave History</h5>
        <div class="row">
          <div class="col-md-12 text-right">
            <button @click="openLeaveModal" class="btn btn-outline-primary btn-sm">Add Leave</button>
          </div>
        </div>
        <leave-records :selectedTab="selectedTab" :upcomingLeaves="upcomingLeaves" tableId="myLeavesTable" :leaves="myLeaves"/>
      </div>
      </div>
      <add-leave-modal ref="addLeaveModal"/>
    </div>
</template>
<script>
import {db} from "@/firebase/init";
import md5 from "crypto-js/md5";
import AddLeaveModal from "@/components/Admin/AdminDashboard/modal/addLeaveModal.vue";
import LeaveRecords from "@/components/Admin/AdminDashboard/leaveRecords.vue";
import moment from "moment-timezone";

export default {
  name: 'LeaveManagement',
  components: {LeaveRecords, AddLeaveModal},
  data() {
    return {
      selectedTab: 'allLeaves',
      leaves: [],
      loading: false,
      selectedIndex: -1,
      isHR: false,
      listener: null,
    }
  },
  beforeDestroy() {
    if(this.listener){
      this.listener()
    }
  },
  mounted() {
    console.log('query params', this.$route.query.type)
    this.getAllLeaves()
    this.getHrRole()
  },
  computed: {
    showAllLeaves() {
      return this.type === 'allLeaves' && this.isHR
    },
    type() {
      return this.$route.query.type
    },
    upcomingLeaves() {
      const array = [];
      const date = moment(new Date()).format('YYYY-MM-DD');
      const dateAfter30 = moment().tz('America/New_York').clone().add(30, 'days').format('YYYY-MM-DD');
      this.leaves.map(el => {
        if(el.leaveDays && el.status === 'approved') {
          const obj = el.leaveDays.find(el2 => el2 <= dateAfter30 && new Date(el2) >= new Date(date) && el.email !== this.user.email);
          console.log(obj)
          if(obj) {
            array.push(el)
          }
        } else if(el.partialLeave && el.partialLeave.date<= dateAfter30 && new Date(el.partialLeave.date) >= new Date(date) && el.status === 'approved' && el.email !== this.user.email) {
          array.push(el)
        }
      })
      console.log('upcomingLeaves', array);
      array.sort((a, b) => {
        const aMin = a.leaveDays && a.leaveDays.length ? Math.min(...a.leaveDays.map(d => new Date(d).getTime())) : (a.partialLeave ? new Date(a.partialLeave.date).getTime() : Infinity);
        const bMin = b.leaveDays && b.leaveDays.length ? Math.min(...b.leaveDays.map(d => new Date(d).getTime())) : (b.partialLeave ? new Date(b.partialLeave.date).getTime(): Infinity);
        return bMin - aMin;
      });
      return array
    },
    myLeaves() {
      return this.leaves.filter(el => el.email === this.user.email)
    },
    user(){
      return this.$store.getters.user;
    }
  },
  watch: {
  },
  methods: {
    openLeaveModal() {
      this.$refs.addLeaveModal.load(this.myLeaves)
    },
    getStatusClass(status) {
      let statusClass = '';
      if(status === 'pending') {
        statusClass = 'badge-warning';
      } else if(status === 'approved') {
        statusClass = 'badge-success';
      } else if(status === 'rejected') {
        statusClass = 'badge-danger';
      }
      return statusClass;
    },
    emailHashGravatar(email) {
      console.log('email,', email)
      if (!email) {
        return null
      } else {
        return md5(email.toLowerCase()).toString()
      }
    },
    async getAllLeaves() {
      this.loading = true;
      this.leaves = []
      this.listener = await db.collection('leaveRecords').onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added'){
            console.log('addin new', 418)
            this.leaves.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'modified') {
            console.log('modified')
            this.leaves = this.leaves.filter(el => el.id !== changeDoc.doc.id)
            this.leaves.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'removed') {
            this.leaves = this.leaves.filter(el => el.id !== changeDoc.doc.id)
          }
        });
      });
      this.loading = false;
    },
    async getHrRole() {
      const ref = await db.collection('users').doc(this.user.uid).get();
      if(ref.exists) {
        const {isHR} = ref.data()
        this.isHR = isHR;
        this.selectedTab = this.isHR ? this.selectedTab = 'allLeaves' : this.selectedTab = 'myLeaves'
      }
      this.loading = false;
    }
  }
}

</script>
<style scoped>

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.table-light{
  background: #fafafa !important;
}
</style>
